import script from "./GSTInvoiceView.vue?vue&type=script&setup=true&lang=js"
export * from "./GSTInvoiceView.vue?vue&type=script&setup=true&lang=js"

import "./GSTInvoiceView.vue?vue&type=style&index=0&id=18e1edda&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18e1edda"]])

export default __exports__